module.exports = __webpack_public_path__ + "static/media/newsletter-december-2022-3.c9abaa40.jpg";